import React from "react";
import "./index.css";

const Policies = () => {
    return (
        <div className="policies-container">
            <div className="policies-header">
                <h1>Privacy Policy</h1>
            </div>
            <div className="policies-content">
                <section>
                    <h2>Introduction</h2>
                    <p>
                        Welcome to Viyash. This Privacy Policy outlines how we collect, use,
                        disclose, and safeguard your personal information when you visit our
                        website or use our services.
                    </p>
                </section>

                <section>
                    <h2>Information We Collect</h2>
                    <ul>
                        <li>
                            <strong>Personal Data:</strong> Includes your name, email address,
                            contact details, and any other information you provide directly.
                        </li>
                        <li>
                            <strong>Usage Data:</strong> Information on how you access and use
                            our website, including IP addresses, browser type, and operating
                            system.
                        </li>
                        <li>
                            <strong>Cookies and Tracking Technologies:</strong> Details about
                            cookies used on our site and your rights concerning them.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>Use of Your Information</h2>
                    <ul>
                        <li>To provide, operate, and maintain our website and services.</li>
                        <li>To improve our website, services, and user experience.</li>
                        <li>
                            To communicate with you, including responding to your inquiries,
                            providing updates, and sending marketing information (where consent
                            is obtained).
                        </li>
                        <li>To comply with legal obligations and protect against fraud.</li>
                    </ul>
                </section>

                <section>
                    <h2>Sharing Your Information</h2>
                    <p>We do not share your personal data with third parties except:</p>
                    <ul>
                        <li>With your consent.</li>
                        <li>To comply with legal obligations.</li>
                        <li>
                            With trusted service providers who assist us in operating our
                            website and services.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>Data Security</h2>
                    <p>
                        We implement reasonable security practices to protect your personal
                        data from unauthorized access, alteration, or disclosure. Our security
                        measures include encryption, access controls, and regular security
                        assessments.
                    </p>
                </section>

                <section>
                    <h2>Your Rights</h2>
                    <ul>
                        <li>
                            <strong>Access and Correction:</strong> You can request access to
                            your personal data and correct inaccuracies.
                        </li>
                        <li>
                            <strong>Deletion:</strong> You can request the deletion of your
                            personal data where applicable.
                        </li>
                        <li>
                            <strong>Withdrawal of Consent:</strong> If you have provided
                            consent, you may withdraw it at any time.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>Cookies and Tracking Technologies</h2>
                    <p>
                        Detailed explanation of cookies and similar tracking technologies used
                        on the website. Information on how users can manage cookies through
                        their browser settings.
                    </p>
                </section>

                <section>
                    <h2>International Data Transfers</h2>
                    <p>
                        We retain your personal data only as long as necessary to fulfill the
                        purposes outlined in this Privacy Policy unless a longer retention
                        period is required or permitted by law.
                    </p>
                </section>

                <section>
                    <h2>Third-Party Links</h2>
                    <p>
                        Our website may contain links to third-party websites. We are not
                        responsible for the privacy practices of these websites and encourage
                        you to read their privacy policies.
                    </p>
                </section>

                <section>
                    <h2>Updates to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. Any changes will
                        be posted on this page, and we encourage you to review it
                        periodically.
                    </p>
                </section>

                <section>
                    <h2>Contact Us</h2>
                    <p>
                        If you have any questions or concerns about this Privacy Policy or the
                        way your information is handled, please contact us at{" "}
                        <strong>[  ]</strong>.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Policies;